import React from 'react';
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import TiTick from 'react-icons/lib/ti/tick'

const SIGNUP_STEPS = [
	{step: 1, stepText : 'Company and login information completed'},
	{step: 2, stepText : 'Payment completed'},
	{step: 3, stepText : 'Manual selected'},
	{step: 4, stepText : 'Sympro oauth verification initiated'},
	{step: 5, stepText : 'Sympro oauth verification completed'},
	{step: 6, stepText : 'Master template imported (First time login)'},
]


class CompanySignupStep extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {step_completed} = this.props;
		let stepReachedText = "n/a";
		let stepsUI = []
		SIGNUP_STEPS.map(s => {
			if(s.step === step_completed){
				stepReachedText = s.stepText
			}

			const stepDetailedText = `${s.step}) ${s.stepText}`

			stepsUI.push(
				<li>
					{(s.step <= step_completed) ? <span>{	stepDetailedText}  <TiTick color="green"/></span > : <span style={{color:"rgb(233, 71, 49)"}}>{stepDetailedText}</span>}
				</li>
			)
		})
		return (
			<div className="dashboard-table-data templete-page">
				<Panel id="collapsible-panel-example-2">
			          <Panel.Heading>
			            <Panel.Title toggle>
			              	Signup Status <span style={{marginLeft: "45%", color:"black", fontWeight: "normal"}}>{`${stepReachedText}`}</span>
			            </Panel.Title>
			          </Panel.Heading>
			          <Panel.Collapse>
			            <Panel.Body>
			            	<table className="dashboard-table">
								<tbody>
									<tr>
										<td width="100%">
											<ul>
												{stepsUI}
											</ul>
										</td>
									</tr>
								</tbody>
							</table>
			             
			            </Panel.Body>
			          </Panel.Collapse>
			        </Panel>
			</div>
		)
	}
}

export default CompanySignupStep;


// WEBPACK FOOTER //
// ./src/Components/Modules/CompanySignupStep.js